import { Typography } from "@mui/material";
import { StarOutlineIcon } from "src/components/icons/ResultIcons";

export default function Koti_Footer() {
  return (
    <div>
      <div className="center">
        <StarOutlineIcon />
        <Typography variant="body2" color="primary" align="center">
          Klikkaa tähteä aktivoidaksesi sen.
        </Typography>
      </div>
      <Typography variant="body2" color="primary" align="center">
        Tähdellä merkitylle sivulle siirrytään automaattisesti kirjautumisen jälkeen tai
        klikkaamalla vasemmassa yläkulmassa olevaa logoa.
      </Typography>
    </div>
  );
}
